import React from 'react';
import { connect } from 'react-redux';
import { Paper, FlatButton, FontIcon, Stepper, Step, StepLabel, RaisedButton } from 'material-ui';
import {
  updateProps as updatePropsAction,
} from '../../../../stores/contracting/template-list/template-list-actions';
import FormWithButton from './components/formWithButtons';
import TemplatesSelection from './components/select-template';
import SaveAsForm from '../../contract-activities-products/publish-draft-content/save-as-template';
import { saveAsANewTemplate } from '../../../../stores/contracting/dialogs/dialog-constants';

const invisibleStepper = ['wannaCopy', 'templateList', 'saveAsForm'];
class CreateTemplateDraftRouter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.rateTemplatesCount ? 'wannaCopy' : 'startFromScratch',
      selectedTemplate: null,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (!this.props.rateTemplatesCount && nextProps.rateTemplatesCount) {
      this.setState({
        show: 'wannaCopy',
      });
    }
  }

  goToSaveAsForm = () => this.setState({
    show: 'saveAsForm',
  });

  fromScratch = () => this.setState({
    show: 'startFromScratch',
  });

  yesIWantToCopy = () => this.setState({
    show: 'templateList',
  });

  goBack = () => {
    const { rateTemplatesCount } = this.props;
    const { show } = this.state;
    if (!rateTemplatesCount || show === 'wannaCopy') this.context.router.goBack();
    else if (show === 'startFromScratch') {
      this.setState({ show: 'wannaCopy' });
    } else {
      this.setState({ show: invisibleStepper[invisibleStepper.indexOf(show) - 1] })
    }
  }
  selectATemplate = template => {
    this.setState({ selectedTemplate: template });
    this.props.updatePropsForSaveAs({
      newDraftStartDate: template.startDate,
      newDraftEndDate: template.endDate,
      contractId: template._id,
      sourceTemplatePeriod: {
        startDate: template.startDate,
        endDate: template.endDate,
      },
    });
  };
  unselect = () => {
    this.setState({ selectedTemplate: null });
    this.props.updatePropsForSaveAs({
      sourceTemplatePeriod: {},
      newDraftStartDate: undefined,
      newDraftEndDate: undefined,
      contractId: undefined,
    });
  };
  saveAsNewTemplate = () => {
    this.props.saveAsANewTemplateWithDispatch({
      contractId: this.props.saveAsReducerState.contractId,
      templateName: this.props.saveAsReducerState.templateName,
      startDate: this.props.saveAsReducerState.newDraftStartDate,
      endDate: this.props.saveAsReducerState.newDraftEndDate,
    })
  };
  onSaveAsDismiss = () => {
    this.props.clearSaveAsReducerState();
  };
  render() {
    // const { startDate, endDate, locationId, buyerName } = location.query;
    const { templates, saveAsReducerState, updatePropsForSaveAs } = this.props;
    const {
      show,
      selectedTemplate,
    } = this.state;
    return (
      <div>
        <Stepper style={{ marginTop: '24px' }} activeStep={0}>
          <Step>
            <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
              <div style={{ width: '100%', textAlign: 'center' }}>
                Create Rate Template
              </div>
            </StepLabel>
          </Step>
          <Step>
            <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
              <div style={{ width: '100%', textAlign: 'center' }}>
                Enter Rates & Required Information
              </div>
            </StepLabel>
          </Step>
          <Step>
            <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
              <div style={{ width: '100%', textAlign: 'center' }}>
                Review & Finalise
              </div>
            </StepLabel>
          </Step>
          <Step>
            <StepLabel style={{ height: '32px', paddingLeft: 0 }}>
              <div style={{ width: '100%', textAlign: 'center' }}>
                Send Rates to Partners
              </div>
            </StepLabel>
          </Step>
        </Stepper>
        <Paper style={{ width: '700px', margin: '32px auto auto' }}>
          <div style={{ backgroundColor: '#00bcd4', color: '#fff', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'space-between' }}>
            <h4 style={{ width: '50%', color: '#FFFFFF', fontWeight: '500', paddingRight: '32px', textAlign: 'right' }}>Create Rate Template</h4>
            <FlatButton
              icon={<FontIcon className="tc-icon-arrow_back" color="white" />}
              label="back"
              style={{ color: 'white' }}
              onTouchTap={this.goBack}
            />
          </div>
          {
            (() => {
              if (show === 'wannaCopy') {
                return (
                  <div style={{ padding: '24px' }}>
                    <div style={{ fontSize: '14px' }}>Would you like to use a copy of an existing rate template, then make changes?</div>
                    <br/>
                    <div className="flex-tc-sb" style={{ marginTop: '32px' }}>
                      <RaisedButton
                        primary
                        labelStyle={{ textTransform: 'none' }}
                        onClick={this.fromScratch}
                        label="No, start from scratch"
                      />
                      <RaisedButton
                        secondary
                        labelStyle={{ textTransform: 'none' }}
                        label="Yes"
                        onClick={this.yesIWantToCopy}
                      />
                    </div>
                  </div>
                );
              }
              if (show === 'templateList') {
                return (
                  <div style={{ margin: '16px 32px' }}>
                    <TemplatesSelection
                      style={{ maxHeight: '500px', overflowY: 'scroll' }}
                      templates={templates}
                      selectedTemplates={selectedTemplate ? [selectedTemplate] : []}
                      label={'Select'}
                      selectedComponent={
                        <FlatButton
                          label="Unselect"
                          style={{ position: 'relative', top: '-8px' }}
                          secondary
                          onClick={this.unselect}
                        />
                      }
                      onConfirm={this.selectATemplate}
                    />
                    <RaisedButton
                      style={{ margin: '16px 0 32px' }}
                      secondary
                      onClick={this.goToSaveAsForm}
                      disabled={!selectedTemplate}
                      label="Next"
                    />
                  </div>
                )
              }
              if (show === 'saveAsForm') {
                return (
                  <div
                    style={{ padding: '12px' }}
                  >
                    <SaveAsForm
                      {...saveAsReducerState}
                      onFieldChange={({ key, value }) => updatePropsForSaveAs({ [key]: value })}
                      saveAsANewTemplate={this.saveAsNewTemplate}
                      onRequestClose={this.onSaveAsDismiss}
                    />
                  </div>
                )
              }
              if (show === 'startFromScratch') {
                return (
                  <FormWithButton
                    style={{ padding: '12px 24px 24px 24px' }}
                    prefillData={this.props.location.query}
                    copyDataFromTemplate={selectedTemplate}
                  />
                );
              }
            })()
          }
        </Paper>
      </div>
    );
  }
}

CreateTemplateDraftRouter.propTypes = {
  location: React.PropTypes.object,
  updateProps: React.PropTypes.func,
  rateTemplatesCount: React.PropTypes.number,
  saveAsReducerState: React.PropTypes.object,
  templates: React.PropTypes.array,
  updatePropsForSaveAs: React.PropTypes.func,
  clearSaveAsReducerState: React.PropTypes.func,
  saveAsANewTemplateWithDispatch: React.PropTypes.func,
};
CreateTemplateDraftRouter.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
const mapStateToProps = ({ contracting, user }) => ({
  rateTemplatesCount: user.get('rateTemplatesCount'),
  templates: contracting.templateList.get('templates').toJS(),
  saveAsReducerState: contracting.publishDraftDialog.toJS(),
});
const mapDispatchToProps = dispatch => ({
  updateProps: payload => dispatch(updatePropsAction(payload)),
  updatePropsForSaveAs: payload => dispatch({ type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG', payload }),
  saveAsANewTemplateWithDispatch: payload => dispatch(saveAsANewTemplate(payload)),
  clearSaveAsReducerState: () => dispatch({ type: 'CLOSE_PUBLISH_DRAFT_DIALOG' }),
});
export default connect(mapStateToProps, mapDispatchToProps)(CreateTemplateDraftRouter);



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/create-template-draft/router-container.jsx